module.exports = __webpack_public_path__ + "static/img/video-title.bda9854.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/awardPH/img/video-title.png
// module id = QELb
// module chunks = 1